export const variants = {
    OPOP: 'opop',
    CONTACT1: 'contact1',
    CONTACT2: 'contact2',
    CONTACT3: 'contact3',
    CONTROL: 'control'
};



// WEBPACK FOOTER //
// ./assets/js/newPdp/constants/maytestConstants.es.js